// config.js
const SUPABASE_URL = 'https://qfvsxavktigxzrcffzmu.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_tTFMzMyBM8d0W_7PAyTSsQ_VlTkAC8C';
const API_URL = `${SUPABASE_URL}/functions/v1`;

export default API_URL;